import {
  CLEAR_SEARCH_DIALOGUE,
  SearchActionsType,
  SET_SEARCH_DIALOGUE, SET_SEARCH_DIALOGUES
} from './actions';
import {
  ISearchActionHandler,
  ISearchInitialState,
  ISearchDialogue
} from './interfaces';

const SearchInitialState: ISearchInitialState = {
  searchDialogues: [],
  searchDialogue: null
};

const setSearchDialogues = ({
  state,
  payload
}: ISearchActionHandler): ISearchInitialState => {
  return {
    ...state,
    searchDialogues: payload as ISearchDialogue[]
  };
};

const setSearchDialogue = ({
  state,
  payload
}: ISearchActionHandler): ISearchInitialState => {
  return {
    ...state,
    searchDialogue: payload as ISearchDialogue
  };
};

const clearSearchDialogue = ({
  state
}: ISearchActionHandler): ISearchInitialState => {
  return {
    ...state,
    searchDialogue: null
  };
};

const searchReducerHandlers = new Map([
  [SET_SEARCH_DIALOGUES, setSearchDialogues],
  [SET_SEARCH_DIALOGUE, setSearchDialogue],
  [CLEAR_SEARCH_DIALOGUE, clearSearchDialogue]
]);

const searchReducer = (state = SearchInitialState, action: SearchActionsType): ISearchInitialState => {
  const handler = searchReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<ISearchActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default searchReducer;
